var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.588745,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#181413"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1895_16378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5887 3.5C7.89441 3.5 4.08875 7.30564 4.08875 12.0001C4.08875 16.6947 7.89441 20.5 12.5887 20.5C17.2835 20.5 21.0887 16.6947 21.0887 12.0001C21.0887 7.30595 17.2836 3.5 12.5887 3.5ZM16.4867 15.7595C16.3345 16.0092 16.0077 16.0884 15.758 15.9351C13.7622 14.7161 11.2499 14.4399 8.29117 15.116C8.00605 15.1809 7.72185 15.0023 7.65689 14.7171C7.59163 14.4318 7.76956 14.1476 8.05538 14.0827C11.2933 13.3429 14.0707 13.6615 16.3111 15.0307C16.5608 15.184 16.6401 15.5099 16.4867 15.7595ZM17.5271 13.445C17.3352 13.7569 16.9272 13.8553 16.6156 13.6635C14.3309 12.2591 10.8481 11.8524 8.14562 12.6727C7.79514 12.7786 7.42496 12.581 7.3186 12.2312C7.21303 11.8807 7.41065 11.5112 7.76052 11.4046C10.8475 10.468 14.6851 10.9217 17.3089 12.5341C17.6205 12.7259 17.719 13.1338 17.5271 13.445ZM17.6165 11.035C14.877 9.40777 10.3571 9.25815 7.74155 10.052C7.32154 10.1794 6.87737 9.94229 6.75009 9.52226C6.6228 9.10204 6.8597 8.65817 7.28002 8.53048C10.2825 7.61898 15.2738 7.79509 18.4279 9.66751C18.8064 9.89173 18.9302 10.3797 18.7059 10.7569C18.4826 11.1347 17.993 11.2593 17.6165 11.035Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1895_16378",
    x: 2.08875,
    y: 3.5,
    width: 21,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1895_16378"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1895_16378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1895_16378",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.14e596da2c3ddf2ba68db0c3abb5575d.svg";
export { ForwardRef as ReactComponent };